import angular from 'angular';
import '../../common/localizationMapService';

const ssoServices = angular.module('applicationModule.ssoServices', []);

ssoServices.factory('SSO', ['SSOAPI', function (SSOAPI) {
    'use strict';

    return {
        get: function (appId) {
            return SSOAPI.get(appId);
        },
        save: function (sso) {
            return SSOAPI.save(sso);
        }
    };
}]);

ssoServices.service('SSOAPI', ['$http', 'AppsoupAPI', function ($http, AppsoupAPI) {
    'use strict';

    const API_URL = AppsoupAPI.API_URL + '/app/sso/';

    this.get = function (appId) {
        return $http.get(API_URL, {params: angular.extend({application_id: appId})});
    };

    this.save = function (sso) {
        return $http.put(API_URL + 'update', sso);
    };
}]);

export default ssoServices;
